module.exports = __webpack_public_path__ + "media/images/new/trail_maps_laptop-f7aa2678f818f18e338c9ca461711711.png";